var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 3.34122C8.63984 3.34122 2.6665 9.31455 2.6665 16.6746C2.6665 24.0346 8.63984 30.0079 15.9998 30.0079C23.3598 30.0079 29.3332 24.0346 29.3332 16.6746C29.3332 9.31455 23.3598 3.34122 15.9998 3.34122ZM15.9998 27.3412C10.1198 27.3412 5.33317 22.5546 5.33317 16.6746C5.33317 10.7946 10.1198 6.00788 15.9998 6.00788C21.8798 6.00788 26.6665 10.7946 26.6665 16.6746C26.6665 22.5546 21.8798 27.3412 15.9998 27.3412ZM13.3332 19.5679L22.1198 10.7812L23.9998 12.6746L13.3332 23.3412L7.99984 18.0079L9.87984 16.1279L13.3332 19.5679Z",
    fill: "#576B75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCircle);
export default __webpack_public_path__ + "static/media/checkbox-circle.352aadc64ec825ccc6afacd70b599fe9.svg";
export { ForwardRef as ReactComponent };